<template>
  <div>
    <create :useObject="2"></create>
  </div>
</template>

<script>
import Create from '../common/Create.vue'
export default {
  components: {
    Create
  }
}
</script>
